import styled from '@emotion/styled';
import { CleanHeader } from '@/components/ui/CleanHeader';
import { ContactForm } from '@/components/ui/ContactForm';
import { useNavigation } from '@/hooks/useNavigation';

const PolicyPage = styled.div`
  max-width: 430px;
  margin: 0 auto;
  padding: 16px;
  min-height: 100vh;
  background: #ffffff;
`;

const Content = styled.div`
  margin-top: 24px;
`;

export function FeedbackPage() {
  const { goBack, canGoBack } = useNavigation();

  return (
    <PolicyPage>
      <CleanHeader title="Feedback" showBack={canGoBack} onBack={goBack} />
      <Content>
        <ContactForm />
      </Content>
    </PolicyPage>
  );
}
